import React from "react";
import { Grid, TextField } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import { STRegenerateButton, STWrapper } from "./styles";
import { observable } from "mobx";
import { observer, inject } from "mobx-react";
import { IAuthStore } from "@src/Stores/Auth/types";
import STPageHeader from "@src/Components/Ui/STPageHeader";

interface IProps {
  auth?: IAuthStore;
}

@inject("auth")
@observer
export default class QuickLogin extends React.Component<IProps> {
  @observable pinCode: string = "";

  getPin = async () => {
    let value = await this.props.auth.getPin();
    this.pinCode = value;
  };
  handleRenegerate = async () => {
    let value = await this.props.auth.regeneratePin();
    this.pinCode = value;
  };

  componentDidMount = () => {
    this.getPin();
    document.title = Values.getLocalizationValue("quickLogin");
  };

  render() {
    return (
      <STWrapper>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="flex-start"
        >
          <STPageHeader>
            {Values.getLocalizationValue("quickLogin")}
          </STPageHeader>

          <Grid item>
            <TextField
              label={Values.getLocalizationValue("sixDigitCode")}
              value={this.pinCode}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <STRegenerateButton
            variant="contained"
            color="primary"
            onClick={this.handleRenegerate}
          >
            {Values.getLocalizationValue("regenerate")}
          </STRegenerateButton>
        </Grid>
      </STWrapper>
    );
  }
}
